import HeadInjector from "./HeadInjector.js";
export default HeadInjector;
